import React from 'react';
import accessibiliteDocument from '../../media/declaration_d_accessibilite_RGAA.pdf';
import AffichageResponsive from '../Commun/AffichageResponsive';
import BoutonPdfTelechargeable from '../Commun/Fichier/BoutonPdfTelechargeable';

const AccessibiliteComponent = () => {
    return (
        <>
            <h1>Accessibilité</h1>
            <br />
            <AffichageResponsive
                composantDesktop={
                    <>
                        <iframe
                            className="iframe"
                            title="Accessibilite"
                            width="100%"
                            src={accessibiliteDocument}
                        />
                    </>
                }
                composantMobile={
                    <BoutonPdfTelechargeable
                        urlFichier={accessibiliteDocument}
                        label="Télécharger le document d'accessibilité"
                        titreFichier="rgaa4-sia_detenteurs.pdf"
                    />
                }
                pointDeRupture="lg"
            />
        </>
    );
};
export default AccessibiliteComponent;
